import { Injectable } from '@angular/core';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';

/** Display / parse dates as M/D/YYYY to match df-frontdesk add flow. */
@Injectable()
export class AddSessionDateMdYParserFormatter extends NgbDateParserFormatter {
  parse(value: string): NgbDateStruct | null {
    const v = (value ?? '').trim();
    if (!v) {
      return null;
    }
    const m = moment(v, ['M/D/YYYY', 'MM/DD/YYYY', 'M/D/YY', 'MM/DD/YY'], true);
    if (!m.isValid()) {
      return null;
    }
    return { year: m.year(), month: m.month() + 1, day: m.date() };
  }

  format(date: NgbDateStruct | null): string {
    if (date == null) {
      return '';
    }
    // Moment object form uses `date` for day-of-month; `day` is day-of-week (0–6).
    const m = moment({ year: date.year, month: date.month - 1, date: date.day });
    return m.isValid() ? m.format('M/D/YYYY') : '';
  }
}
